/**
 * registerSW.js — Service Worker Registration
 *
 * Call once from App.js or index.js to register the PWA service worker.
 * Only registers in production (process.env.NODE_ENV === 'production').
 */

export function registerServiceWorker() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[SW] Registered:', reg.scope);

          // Check for updates every 30 minutes
          setInterval(() => reg.update(), 30 * 60 * 1000);

          // Notify user when update is available
          reg.addEventListener('updatefound', () => {
            const newWorker = reg.installing;
            if (!newWorker) return;

            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'activated' && navigator.serviceWorker.controller) {
                // New version available — user will get it on next reload
                console.log('[SW] New version available');
              }
            });
          });
        })
        .catch((err) => {
          console.warn('[SW] Registration failed:', err);
        });
    });
  }
}

export function unregisterServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister());
  }
}